import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-cream-50" data-id="element-134">
      <div className="max-w-4xl mx-auto" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-136">
          <div className="inline-flex items-center justify-center p-3 bg-navy-900/5 rounded-full mb-6" data-id="element-137">
            <AlertCircle className="w-8 h-8 text-navy-900" data-id="element-138" />
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 mb-6" data-id="element-139">
            El problema no es tu producto. El problema no es tu precio.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white p-8 sm:p-10 rounded-2xl shadow-xl border border-cream-100 relative overflow-hidden" data-id="element-140">
          {/* Decorative accent */}
          <div className="absolute top-0 left-0 w-2 h-full bg-gold-500" data-id="element-141" />

          <p className="text-xl sm:text-2xl font-serif text-navy-800 mb-8 leading-relaxed font-medium" data-id="element-142">
            El problema es que estás operando como un "catálogo viviente" y no
            como una autoridad premium.
          </p>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-143">
            <p data-id="element-144">
              En Estados Unidos, el tiempo es el activo más caro. Cada minuto
              que pasas intentando convencer a un "curioso" que no tiene el
              dinero o la intención de compra, le estás robando una oportunidad
              al cliente ideal que realmente necesita tu ayuda hoy mismo.
            </p>
            <p className="font-semibold text-navy-900 bg-cream-50 p-4 rounded-lg border-l-4 border-navy-900" data-id="element-145">
              Si sigues vendiendo por "amabilidad", seguirás recibiendo
              "vistos".
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}